// based on rc-checkbox 2.1.7
export { default } from './src/';
